import { render } from "./ImgSquare.vue?vue&type=template&id=22d9032f"
import script from "./ImgSquare.vue?vue&type=script&lang=js"
export * from "./ImgSquare.vue?vue&type=script&lang=js"

import "./ImgSquare.vue?vue&type=style&index=0&id=22d9032f&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__